import type { SeatmapData } from '@/types';
import { mapDtoToSeatmapData, type SeatmapDataDTO } from '@/utils/dtoTransformers/seatmapDTO';

export async function fetchSeatmap(name: string): Promise<SeatmapData | null> {
  const params = new URLSearchParams({
    name: name
  });

  try {
    const response = await fetch('/of2/json/seatmap?' + params.toString(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    if (!response.ok) {
      return null;
    }
    const data: SeatmapDataDTO = await response.json();
    try {
      return data ? mapDtoToSeatmapData(data) : null;
    } catch (e) {
      console.error("Failed to map seatmap DTO:", e);
      return null;
    }
  } catch {
    return null;
  }
}

export async function fetchSeatmapBackground(name: string): Promise<string | null> {
  const params = new URLSearchParams({
    cacheBust: new Date().getTime().toString()
  });

  try {
    const response = await fetch('/seatmaps/' + name + '/map.png?' + params.toString(), {
      method: 'GET',
    });
    if (!response.ok) {
      return null;
    }
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  } catch {
    return null;
  }
}
